import { isPresent } from "./validation";

export function formatPercentage(value) {
  return isPresent(value) ? `${Math.round(value * 100)} %` : null;
}
